import Modal from '../../../../core/components/core/Util/Modal/CustomModal';

function CancelServiceContractRevenues({ show, onClose, onConfirm }) {
    return (
        <Modal
            show={show}
            handleShow={() => { }}
            handleClose={onClose}
            handleCancel={onClose}
            handleConfirm={onConfirm}
            title="Cancelar Receitas"
            content={
                <p>
                    Tem certeza que deseja <strong>cancelar todas as receitas</strong> deste contrato?
                    Esta ação não poderá ser desfeita.
                </p>
            }
            showButtons={true}
            showHeader={true}
            confirmButtonText="Cancelar"
            cancelButtonText="Não"
        />
    );
}

export default CancelServiceContractRevenues;
